<template>
  <div class="list-block">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ListBlock',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.list-block {
  background: #fff;
  border-radius: 6px;
  padding: 16px 24px;
  margin-top: 16px;

  &:first-child {
    margin-top: 0;
  }
}
</style>
